import { Link } from "react-router-dom";

const services = [
  { label: "Sliding Door Repair", path: "/sliding-door-repair/" },
  { label: "Window Hardware Repair", path: "/window-hardware-repair/" },
  { label: "Emergency Board-Up", path: "/emergency-board-up/" },
];

interface Props {
  neighborhood: string;
}

export default function RelatedServicesBlock({ neighborhood }: Props) {
  return (
    <section className="w-full bg-white py-16 md:py-20">
      <div className="max-w-[1080px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-[28px] font-bold text-[#064e3b] text-center mb-10">
          Related Services in {neighborhood}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {services.map((s) => (
            <Link
              key={s.path}
              to={s.path}
              className="block bg-white rounded-lg border-l-4 border-[#064e3b] p-5 hover:bg-[#fefce8] transition-colors"
            >
              <p className="text-sm font-bold text-[#064e3b]">
                {s.label} in {neighborhood}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}